import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FiSiteDesignBrandEditorComponent } from './fi-site-design-brand-editor.component';
import { FiBrandEditorSiteNameCardComponent } from './fi-brand-editor-site-name-card/fi-brand-editor-site-name-card.component';
import { FiBrandEditorSiteNameEditorDialogComponent } from './fi-brand-editor-site-name-card/fi-brand-editor-site-name-editor-dialog/fi-brand-editor-site-name-editor-dialog.component';
import { FiBrandEditorPreviewCardComponent } from './fi-brand-editor-preview-card/fi-brand-editor-preview-card.component';
import { FiSiteDesignBrandPreviewDialogComponent } from './fi-brand-editor-preview-card/fi-site-design-brand-preview-dialog/fi-site-design-brand-preview-dialog.component';
import { FiBrandEditorPageLayoutCardComponent } from './fi-brand-editor-page-layout-card/fi-brand-editor-page-layout-card.component';
import { FiBrandEditorImagesCardComponent } from './fi-brand-editor-images-card/fi-brand-editor-images-card.component';
import { FiBrandImageEditorComponent } from './fi-brand-editor-images-card/fi-brand-image-editor/fi-brand-image-editor.component';
import { FiBrandEditorBrandColorsCardComponent } from './fi-brand-editor-brand-colors-card/fi-brand-editor-brand-colors-card.component';
import { FiBrandColorPickerComponent } from './fi-brand-editor-brand-colors-card/fi-brand-color-picker/fi-brand-color-picker.component';
import { FiTwoColumnsContainerModule } from '@fi-shared/fi-two-columns-container/fi-two-columns-container.module';
import { MatCardModule } from '@angular/material/card';
import { FiAppTextSharedModule } from '@fi-shared/app-text';
import { MatButtonModule } from '@angular/material/button';
import { FiIconTooltipButtonModule } from '@fi-shared/fi-icon-tooltip-button/fi-icon-tooltip-button.module';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { FiAuthenticateModule } from '@fi-app/authenticate/authenticate.module';
import { FiInsertMediaModule } from '@fi-shared/fi-insert-media/fi-insert-media.module';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { ColorPickerComponent, ColorPickerDirective } from 'ngx-color-picker';
import { SelectSearchModule } from '@fi-shared/fi-select-search/select-search.module';
import { FiBrandEditorBusinessAreasCardComponent } from './fi-brand-editor-business-areas-card/fi-brand-editor-business-areas-card.component';
import { FiErrorMessageModule } from '@fi-shared/fi-error-message';

@NgModule({
    imports: [
        CommonModule,
        FiTwoColumnsContainerModule,
        MatCardModule,
        FiAppTextSharedModule,
        MatButtonModule,
        FiIconTooltipButtonModule,
        MatFormFieldModule,
        FormsModule,
        MatInputModule,
        FiAuthenticateModule,
        FiInsertMediaModule,
        MatIconModule,
        MatMenuModule,
        ColorPickerComponent,
        ColorPickerDirective,
        SelectSearchModule,
        FiErrorMessageModule,
    ],
    declarations: [
        FiSiteDesignBrandEditorComponent,
        FiBrandEditorSiteNameCardComponent,
        FiBrandEditorSiteNameEditorDialogComponent,
        FiBrandEditorPreviewCardComponent,
        FiSiteDesignBrandPreviewDialogComponent,
        FiBrandEditorPageLayoutCardComponent,
        FiBrandEditorImagesCardComponent,
        FiBrandImageEditorComponent,
        FiBrandEditorBrandColorsCardComponent,
        FiBrandColorPickerComponent,
        FiBrandEditorBusinessAreasCardComponent,
    ],
})
export class FiSiteDesignBrandEditorModule {}
